import { mediaQueryLarge } from '@theme/utilities';

/**
 * FAQ page (templates/page.json): keeps each answer open or closed when the viewport crosses Horizon's large breakpoint.
 * Horizon's accordion-custom re-applies its default (closed) state whenever its mediaQueryLarge changes
 * (assets/accordion-custom.js, #handleMediaQueryChange), so rotating a phone closed every open answer; today's FAQ keeps
 * them open. This module remembers which FAQ rows the shopper opened and re-opens them right after Horizon's reset.
 * It builds its own MediaQueryList from Horizon's query text (so a Horizon breakpoint change is followed); that list is
 * created after Horizon's, and change events fire in the order the lists were created, so this listener runs after
 * Horizon's. Rows already open when the module loads (opened on a slow connection) are remembered too.
 * Loaded only by blocks/zerbay-faq-banner.liquid.
 */
const ROWS = 'main accordion-custom > details';

/** @type {WeakSet<HTMLDetailsElement>} */
const opened = new WeakSet();

if (document.querySelector('.zb-faq')) {
  for (const details of document.querySelectorAll(ROWS)) {
    if (details instanceof HTMLDetailsElement && details.open) opened.add(details);
  }

  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement) || !details.matches(ROWS)) return;
      if (details.open) opened.add(details);
      else opened.delete(details);
    },
    true
  );

  const query = window.matchMedia(mediaQueryLarge.media);
  query.addEventListener('change', () => {
    for (const details of document.querySelectorAll(ROWS)) {
      if (details instanceof HTMLDetailsElement && opened.has(details)) details.open = true;
    }
  });
}
